<script lang="ts" setup>
// ================================
// IMPORTS
// ================================
// Vue
import { computed } from "vue"
import { useI18n } from "vue-i18n"

const { t } = useI18n({
    messages: {
        fr: {
            title: "Paramétrage des alarmes",
            breadcrumb: {
                accueil: "Accueil",
                utilisateur: "Utilisateur",
                param: "Paramétrage des alarmes",
            },
        },
    },
})

const getBreadcrumb = computed(() => {
    return [
        { icon: "pi pi-home", label: t("breadcrumb.accueil"), route: "/" },
        {
            icon: "pi pi-user",
            label: t("breadcrumb.utilisateur"),
        },
        { icon: "pi pi-bell", label: t("breadcrumb.param") },
    ]
})
</script>

<template>
    <div class="page page-user-alarm">
        <!-- Header avec titre -->
        <HeaderPage :title="t('title')" :breadcrumb="getBreadcrumb" />
        <FormUserAlarmSetting />
    </div>
</template>
